const currencyFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const CreditNoteGridHeader = [
  {
    field: "rowNumber",
    headerName: "#",
    minWidth: 45,
    flex: 0.4,
    sortable: false,
    filterable: false,
    headerClassName: "super-app-theme--header",
    groupable: false,
    aggregable: false,
  },
  {
    field: "InvoiceNr",
    headerName: "Numri i Fatures",
    minWidth: 110,
    flex: 0.9,
    editable: false,
    headerClassName: "super-app-theme--header",
    groupable: false,
    aggregable: false,
  },
  {
    field: "Date",
    headerName: "Data",
    minWidth: 88,
    flex: 0.7,
    editable: false,
    headerClassName: "super-app-theme--header",
    groupable: false,
    aggregable: false,
  },
  {
    field: "AccountName",
    headerName: "Furnitori",
    minWidth: 220,
    flex: 3.0,
    editable: false,
    headerClassName: "super-app-theme--header",
    groupable: false,
    aggregable: false,
  },
  {
    field: "AmountWithoutVAT",
    headerName: "Vlera",
    type: "string",
    minWidth: 110,
    flex: 1.0,
    editable: false,
    headerClassName: "super-app-theme--header",
    groupable: true,
    valueFormatter: (value) => {
      if (!value) {
        return value;
      }
      return currencyFormatter.format(value);
    },
  },
  {
    field: "VATTotal",
    headerName: "TVSH",
    type: "string",
    minWidth: 100,
    flex: 1.0,
    editable: false,
    headerClassName: "super-app-theme--header",
    groupable: true,
    valueFormatter: (value) => {
      if (!value) {
        return value;
      }
      return currencyFormatter.format(value);
    },
  },
  {
    field: "Total",
    headerName: "Total",
    type: "string",
    minWidth: 110,
    flex: 1.0,
    editable: false,
    headerClassName: "super-app-theme--header",
    groupable: true,
    valueFormatter: (value) => {
      if (!value) {
        return value;
      }
      return currencyFormatter.format(value);
    },
  },
];

export default CreditNoteGridHeader;
